import { Fragment, useEffect, useState } from "react";
import TableCell from "@mui/material/TableCell";
import { useTranslation } from "react-i18next";
import useAxios from "../../../hook/useAxios";
import DeleteAlert from "../../ErrorAndAlert/DeleteAlert";
import { ScientificName } from "../../../type/scientificName";
import ActionItem from "../../Global/ActionItem";
import ScientificNamesTooltip from "./ScientificNamesTooptip";
import { toast } from "react-toastify";

const ScientificNameTableItem: React.FC<{
  names: ScientificName;
  fetchData: () => void;
  lastIndex: number;
}> = ({ names: propsNames, fetchData: propFetchData, lastIndex }) => {
  const { i18n, t } = useTranslation();
  const [showDelete, isShowDelete] = useState<boolean>(false);

  const { response: deleteR, fetchData } = useAxios(
    process.env.REACT_APP_API_URL +
      `/api/admin/scientific_names/${propsNames.id}/delete/`,
    "DELETE",
    false,
    `${t("Message.Successful delete")}`,
    true,
    true
  );
  useEffect(() => {
    if (deleteR !== null) {
      isShowDelete(false);
      propFetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteR]);

  const deleteAction = () => {
    if (propsNames.is_deletable) {
      isShowDelete(true);
    } else {
      toast.error(t("Message.Invalid species delete"));
    }
  };

  const hide = () => {
    isShowDelete(false);
  };

  const deleteItem = () => {
    fetchData({});
  };

  const name =
    propsNames.species_name_transes.fr === ""
      ? propsNames.species_name_transes.en
      : propsNames.species_name_transes.fr;
  return (
    <Fragment>
      <TableCell align="left">
        {i18n.language === "fr" ? name : propsNames.species_name_transes.en}
      </TableCell>
      <TableCell>
        <div className="flex items-center">
          {i18n.language === "fr"
            ? propsNames.scientific_name_transes[0].fr ||
              propsNames.scientific_name_transes[0].en
            : propsNames.scientific_name_transes[0].en}
          {propsNames.scientific_name_transes.length > 1 && (
            <ScientificNamesTooltip
              names={propsNames.scientific_name_transes}
            />
          )}
        </div>
      </TableCell>
      <TableCell align="right">
        <ActionItem
          delete={true}
          editLink={`/setting/scientific-names/edit-scientific-name/${propsNames.slug}`}
          deleteAction={deleteAction}
          view=""
          viewLink=""
          historyLink=""
          viewHistory=""
        />
      </TableCell>
      {showDelete && (
        <DeleteAlert
          type={t("Tree Species.Scientific name")}
          hide={hide}
          deleteAction={deleteItem}
        />
      )}
    </Fragment>
  );
};

export default ScientificNameTableItem;
